import { useState, useEffect, useRef } from "react";
import styles from "./ChargingMethodsCard2.module.scss";
import Heading from "../../Typography/Heading/Heading";
import Text from "../../Typography/Text/Text";
import chargeStation from "../../../static/images/chargeStation.png";
import chargeStation_mobile from "../../../static/images/chargeStation_mobile.png";

export default function ChargingMethodsCard2() {
  const [stage2, setStage2] = useState(false);
  const [stage3, setStage3] = useState(false);
  const [stage4, setStage4] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    let counter = 0;
    let tempInterval;
    const wrap = ref.current;

    function timer() {
      counter++;
      if (counter === 2) {
        setStage2(true);
      }
      if (counter === 4) {
        setStage3(true);
      }
      if (counter === 6) {
        setStage4(true);
      }
      if (counter === 8) {
        setStage2(false);
        setStage3(false);
        setStage4(false);
        counter = 0;
      }
    }

    function mouseHover() {
      tempInterval = setInterval(() => {
        timer();
      }, 1000);
    }

    function mouseOut() {
      clearInterval(tempInterval);
      setStage2(false);
      setStage3(false);
      setStage4(false);
      counter = 0;
    }

    wrap.addEventListener("mouseenter", mouseHover);
    wrap.addEventListener("mouseleave", mouseOut);
  }, []);

  return (
    <div ref={ref} className={styles.wrap}>
      <div className={styles.content}>
        <div className={styles.info}>
          <div className={styles.title}>
            <Heading level="h5" fw={600}>
              Зарядка через дисплей <br /> на электрозаряднной станции
            </Heading>
          </div>
          <div className={styles.instructions}>
            <div
              className={
                !stage2 && !stage3 && !stage4
                  ? `${styles.instruction} ${styles.active}`
                  : `${styles.instruction}`
              }
            >
              <Text size="large">
                Выберите тип коннектора: <br />
                ССS Combo 2, CHAdeMO, GB/T или Type 2
              </Text>
            </div>
            <div
              className={
                stage2 && !stage3 && !stage4
                  ? `${styles.instruction} ${styles.active}`
                  : `${styles.instruction}`
              }
            >
              <Text size="large">
                Нажмите на кнопку дисплея <br /> “Начать зарядку”
              </Text>
            </div>
            <div
              className={
                stage2 && stage3 && !stage4
                  ? `${styles.instruction} ${styles.active}`
                  : `${styles.instruction}`
              }
            >
              <Text size="large">
                10 сек-30 сек обмен данными <br /> с электромобилем и запуск
                заряда
              </Text>
            </div>
            <div
              className={
                stage2 && stage3 && stage4
                  ? `${styles.instruction} ${styles.active}`
                  : `${styles.instruction}`
              }
            >
              <Text size="large">
                Нажмите на кнопку дисплея <br /> “Остановить зарядку”
              </Text>
            </div>
          </div>
          <div className={styles.progressBarWrap}>
            <div className={styles.progressBar}>
              <div className={styles.values}>
                <div className={styles.leftValues}>
                  <div className={`${styles.valueLeft} ${styles.active}`}>
                    <Heading level="h5" fw={700}>
                      01
                    </Heading>
                  </div>
                  <div
                    className={
                      stage2
                        ? `${styles.valueLeft} ${styles.active}`
                        : `${styles.valueLeft}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      02
                    </Heading>
                  </div>
                  <div
                    className={
                      stage3
                        ? `${styles.valueLeft} ${styles.active}`
                        : `${styles.valueLeft}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      03
                    </Heading>
                  </div>
                  <div
                    className={
                      stage4
                        ? `${styles.valueLeft} ${styles.active}`
                        : `${styles.valueLeft}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      04
                    </Heading>
                  </div>
                </div>

                <div className={styles.rightValues}>
                  <div
                    className={
                      stage2
                        ? `${styles.valueRight}`
                        : `${styles.valueRight} ${styles.active}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      02
                    </Heading>
                  </div>
                  <div
                    className={
                      stage3
                        ? `${styles.valueRight}`
                        : `${styles.valueRight} ${styles.active}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      03
                    </Heading>
                  </div>
                  <div
                    className={
                      stage4
                        ? `${styles.valueRight}`
                        : `${styles.valueRight} ${styles.active}`
                    }
                  >
                    <Heading level="h5" fw={700}>
                      04
                    </Heading>
                  </div>
                </div>
              </div>

              <div className={styles.scale}>
                <div
                  className={
                    stage4
                      ? `${styles.scaleActive} ${styles.stage4}`
                      : stage3
                      ? `${styles.scaleActive} ${styles.stage3}`
                      : stage2
                      ? `${styles.scaleActive} ${styles.stage2}`
                      : `${styles.scaleActive} `
                  }
                />
              </div>
            </div>
            <div className={styles.imageMobile}>
              <img src={chargeStation_mobile} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.image}>
          <img src={chargeStation} alt="" />
        </div>
      </div>
    </div>
  );
}
